/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Blmanual_Name1Inputs */

const en_resources_blmanual_name1 = /** @type {(inputs: Resources_Blmanual_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery notes by number list`)
};

const fr_resources_blmanual_name1 = /** @type {(inputs: Resources_Blmanual_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLs par liste de numéros`)
};

const es_resources_blmanual_name1 = /** @type {(inputs: Resources_Blmanual_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albaranes por lista de números`)
};

const de_resources_blmanual_name1 = /** @type {(inputs: Resources_Blmanual_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferscheine nach Nummernliste`)
};

const nl_resources_blmanual_name1 = /** @type {(inputs: Resources_Blmanual_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leveringsbonnen per lijst van nummers`)
};

/**
* | output |
* | --- |
* | "Delivery notes by number list" |
*
* @param {Resources_Blmanual_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_blmanual_name1 = /** @type {((inputs?: Resources_Blmanual_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Blmanual_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_blmanual_name1(inputs)
	if (locale === "fr") return fr_resources_blmanual_name1(inputs)
	if (locale === "es") return es_resources_blmanual_name1(inputs)
	if (locale === "de") return de_resources_blmanual_name1(inputs)
	return nl_resources_blmanual_name1(inputs)
});
export { resources_blmanual_name1 as "resources.blManual.name" }